<template>
  <v-list-tile ripple @click="onClick()" :disabled="disabled">
    <v-list-tile-action>
      <v-icon :color="color">{{icon}}</v-icon>
    </v-list-tile-action>
    <v-list-tile-title>{{title}}</v-list-tile-title>
  </v-list-tile>
</template>

<script>
export default {
  props: {
    icon: String,
    color: String,
    title: String,
    onClick: Function,
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style>
</style>
